import { render, staticRenderFns } from "./StoryboardCategoriesList.vue?vue&type=template&id=22e6bb89&scoped=true&"
import script from "./StoryboardCategoriesList.vue?vue&type=script&lang=js&"
export * from "./StoryboardCategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./StoryboardCategoriesList.vue?vue&type=style&index=0&id=22e6bb89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6bb89",
  null
  
)

export default component.exports